import {
  useConfiguration,
  useCreateConfiguration,
  useUpdateConfiguration,
} from '~/client/services/configuration';

export const DASHBOARD_COMPONENTS_CONFIG_KEY = 'dashboardComponentsVisibility';

export interface DashboardComponentsVisibility {
  showRiskPie: boolean;
  showCompliancePie: boolean;
  showAssuranceChart: boolean;
  showAssessmentStatusChart: boolean;
  showJurisdictionMap: boolean;
  showProjectTableTrueColumns: boolean;
}

const DEFAULTS: DashboardComponentsVisibility = {
  showRiskPie: true,
  showCompliancePie: true,
  showAssuranceChart: true,
  showAssessmentStatusChart: false,
  showJurisdictionMap: true,
  showProjectTableTrueColumns: false,
};

export function useDashboardComponentsConfig() {
  const { data, loading, refetch } = useConfiguration(
    DASHBOARD_COMPONENTS_CONFIG_KEY
  );
  const [createConfiguration] = useCreateConfiguration();
  const [updateConfiguration] = useUpdateConfiguration();

  const stored = data?.configuration?.value;
  const visibility: DashboardComponentsVisibility =
    stored && typeof stored === 'object'
      ? { ...DEFAULTS, ...stored }
      : DEFAULTS;

  const exists = Boolean(data?.configuration);

  const save = async (next: DashboardComponentsVisibility) => {
    if (exists) {
      await updateConfiguration({
        variables: {
          key: DASHBOARD_COMPONENTS_CONFIG_KEY,
          input: { value: next, dataType: 'OBJECT' },
        },
      });
    } else {
      await createConfiguration({
        variables: {
          input: {
            key: DASHBOARD_COMPONENTS_CONFIG_KEY,
            value: next,
            description:
              'Controls which chart components are visible on the compliance dashboard',
            dataType: 'OBJECT',
          },
        },
      });
    }
    refetch();
  };

  return { visibility, loading, save };
}
